module.exports = "/_next/static/images/sv-c89f544d90752afcfc46509e18b19c47.svg";